import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { LineChart } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { ChartsLabPage } from "./pages/ChartsLabPage";

export const chartsLabModule: FeatureModule = {
  key: "charts_lab",
  nav: {
    label: "Charts Lab",
    icon: LineChart,
    to: "/charts-lab",
    // Consumes /api/kpi/dashboard, so gate on the same permission as the data.
    requires: "kpi.read",
    order: 123,
    group: "Tools",
  },
  routes: (rootRoute) =>
    [
      createRoute({
        getParentRoute: () => rootRoute,
        path: "/charts-lab",
        component: guarded("kpi.read", ChartsLabPage),
      }),
    ] as unknown as AnyRoute[],
};
